<div class="container-fluid customers-root">
    <div class="table-root">
        <div *ngIf="readingSelected === ReadingsMenuTab.MeterReadings" class="d-flex justify-content-start switch-toggle transparent">
            <a class="separated-toggle-item" [ngClass]="currentTab == 1 ? 'active' : ''" (click)="changeTab(1)">
                <div>
                    {{ 'READING.SUBMITTED' | translate }} <span class="bubble">{{ stats.submitted | number }}</span>
                </div>
            </a>
            <a class="separated-toggle-item" [ngClass]="currentTab == 2 ? 'active' : ''" (click)="changeTab(2)">
                <div>
                    {{ 'READING.FAILED' | translate }} <span class="bubble">{{ stats.failed | number }}</span>
                </div>
            </a>
            <a class="separated-toggle-item" [ngClass]="currentTab == 3 ? 'active' : ''" (click)="changeTab(3)">
                <div>
                    {{ 'READING.REJECTED' | translate }} <span class="bubble">{{ stats.rejected | number }}</span>
                </div>
            </a>
            <a class="separated-toggle-item" [ngClass]="currentTab == 4 ? 'active' : ''" (click)="changeTab(4)">
                <div>
                    {{ 'READING.INACCESSIBLE' | translate }} <span class="bubble">{{ stats.inaccessible | number }}</span>
                </div>
            </a>
            <a class="separated-toggle-item" [ngClass]="currentTab == 5 ? 'active' : ''" (click)="changeTab(5)">
                <div>
                    {{ 'READING.INOPERABLE_METERS' | translate }} <span class="bubble">{{ stats.inoperableMeters | number }}</span>
                </div>
            </a>
        </div>

        <div *ngIf="readingSelected === ReadingsMenuTab.AssignedReadings" class="d-flex justify-content-start switch-toggle transparent">
            <a class="separated-toggle-item" [ngClass]="currentTab == 0 ? 'active' : ''" (click)="changeTab(0)">
                <div>
                    {{ 'READING.ASSIGNED' | translate }} <span class="bubble">{{ stats.assigned | number }}</span>
                </div>
            </a>
        </div>
        
        <div class="table-root-child">
            <div class="table-action-wrapper d-flex align-items-center justify-content-between">
                <div class="search-input">
                    <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
                    <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText" (keydown.enter)="search()"
                        (ngModelChange)="this.searchTextUpdate.next($event)" />
                </div>
                <div class="ml-auto d-flex">
                    <div>
                        <div class="d-flex">
                            <div class="datepicker-container">
                                <label for="dateFrom"> {{ 'READING.DATE_FROM' | translate }} </label>
                                <input type="date" id="dateFrom" name="dateFrom" [ngClass]="
                                !datesValid()
                                  ? 'btn datepicker-icon-error'
                                  : 'btn datepicker-icon'
                                    "
                                     [(ngModel)]="dateFrom" (change)="datesValid() == true && search()"
                                />
                            </div>

                            <div class="datepicker-container">
                                <label for="dateTo" class="right-label"> {{ 'READING.DATE_TO' | translate }}: </label>
                                <input type="date" id="dateTo" name="dateTo" [ngClass]="
                                    dateFrom > dateTo
                                        ? 'btn datepicker-icon-error'
                                        : 'btn datepicker-icon'
                                    " [(ngModel)]="dateTo" (change)="datesValid() == true && search()"
                                />
                            </div>
                            <div class="sort-by-root" (click)="showSortBy = !showSortBy" click-stop-propagation>
                                <div class="dropdown">
                                    <span>{{ 'READING.SORT_BY' | translate}}:</span>
                                    <span>{{ sortByLabelValue.label | translate }}
                                        <img *ngIf="sortByLabelValue.arrow !== 'no'" [ngClass]="{'arrow-up': sortByLabelValue.arrow === 'up'}" src="../../../assets/icons/arrow.svg" />
                                    </span>
                                    <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
                                </div>
                                <div class="dropdown-opened" *ngIf="showSortBy">
                                    <div (click)="sortBy(sortByOptions.NEWEST)">
                                        <div>{{ 'READING.NEWEST' | translate}}</div>
                                    </div>
                                    <div (click)="sortBy(sortByOptions.OLDEST)">
                                        <div>{{ 'READING.OLDEST' | translate}}</div>
                                    </div>
                                    <div *ngIf="readingSelected === ReadingsMenuTab.AssignedReadings" (click)="sortBy(sortByOptions.PRIORITY_DESC)">
                                        <div>{{ 'READING.PRIORITY_DESC' | translate}}</div>
                                    </div>
                                    <div *ngIf="readingSelected === ReadingsMenuTab.AssignedReadings" (click)="sortBy(sortByOptions.PRIORITY_ASC)">
                                        <div>{{ 'READING.PRIORITY_ASC' | translate}}</div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-icon" (click)="download()">
                                <span>{{ 'READING.DOWNLOAD' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filter">
                <div class="filter-list">
                    {{ 'READING.FILTER' | translate}}
                    <app-multi-select-dropdown class="multiselect" [clicked]="clicked"
                        [items]="hasCimDataIntegration ? geographicalRegions : regions"
                        [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
                        (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)">
                    </app-multi-select-dropdown>
                    <app-multi-select-dropdown class="multiselect" [clicked]="clicked"
                        [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
                        [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
                        (shareIndividualCheckedList)="hasCimDataIntegration ? selectSubGeographicalRegion($event) : selectArea($event)">
                    </app-multi-select-dropdown>
                    <app-multi-select-dropdown class="multiselect" [clicked]="clicked" [items]="blocks"
                        [label]= "'READING.BLOCK' | translate" [showMore]="false" [requireApply]="true"
                        (shareIndividualCheckedList)="selectBlock($event)">
                    </app-multi-select-dropdown>
                    <app-multi-select-dropdown class="multiselect" [clicked]="clicked" [items]="rounds"
                        [label]= "'READING.ROUND' | translate" [showMore]="false" [requireApply]="true"
                        (shareIndividualCheckedList)="selectRound($event)">
                    </app-multi-select-dropdown>
                    <!-- <app-multi-select-dropdown class="multiselect" [clicked]="clicked" [items]="plots"
                        [label]= "'Plot'" [showMore]="false" [requireApply]="true"
                        (shareIndividualCheckedList)="selectPlot($event)" (applyFilterEmitter)="reloadTable(1)">
                    </app-multi-select-dropdown> -->
                    <select name="slt-select" (change)="selectSltStatus($event)" class="form-select">
                        <option value="" [selected]="!sltStatus" disabled>
                            {{ 'READING.SLT_STATUS' | translate}}
                          </option>
                          <option [selected]="sltStatus == s.key" *ngFor="let s of sltOptions" value="{{ s.key }}">
                            {{ s.value }}
                          </option>
                    </select>
                </div>
                <div *ngIf="selectedFilters.length > 0">
                    <app-filter-checklist [filters]="selectedFilters" (resetFilterEmitter)="resetFilter($event)" [useApply]="true"
                        (applyFilterEmitter)="applyFilter()" (removeFilterEmitter)="removeFilter($event)">
                    </app-filter-checklist>
                </div>
            </div>
            <div class="table">
                <div *ngIf="true">
                    <table class="table border-bottom">
                        <thead class="table-light">
                            <tr>
                                <th>
                                    <input type="checkbox" class="form-check-input" [checked]="isAllCheckBoxChecked()"
                                        (change)="checkAllCheckBox($event)" />
                                </th>
                                <th>{{ 'READING.ACCOUNT_NO' | translate}}</th>
                                <th>{{ 'READING.ACCOUNT_NAME' | translate}}</th>
                                <th>{{ 'COMMON.BU.SINGLE' | translate }}</th>
                                <th>{{ 'COMMON.UT.SINGLE' | translate }}</th>
                                <th>{{ 'READING.METER_NO' | translate}}</th>
                                <th>{{ 'READING.METER_DIGIT' | translate}}</th>
                                <th>{{ 'READING.PERIOD' | translate}}</th>
                                <th>{{ 'READING.LAR' | translate}}</th>
                                <th>{{ 'READING.PAR' | translate}}</th>
                                <th>{{ 'READING.SLT_STATUS' | translate}}</th>
                                <th>{{ 'READING.VALIDATION_STATUS' | translate}}</th>
                                <th *ngIf="readingSelected === ReadingsMenuTab.AssignedReadings">{{ 'READING.PRIORITY_STATUS' | translate}}</th>
                                <th>{{ 'READING.CONSUMPTION' | translate}}</th>
                                <th>{{ 'READING.ESTIMATION_STATUS' | translate}}</th>
                                <th>{{ 'READING.CREATION_DATE' | translate}}</th>
                                <th>{{ 'READING.AUDIT_STATUS' | translate}}</th>
                                <!-- <th>Status</th> -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="
                                let meterReading of meterReadings;
                                let i = index
                                " (click)="selectReading(meterReading.id)">
                                <td>
                                    <input type="checkbox" class="form-check-input" value="{{ meterReading.id }}" />
                                </td>

                                <td (click)="setFilterStorage()">
                                    {{ meterReading.accountNumber | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading?.accountName | hasValue }}
                                </td>
                                <td *ngIf="!hasCimDataIntegration" (click)="setFilterStorage()">
                                    {{ meterReading.region | hasValue }}
                                </td>
                                <td *ngIf="hasCimDataIntegration" (click)="setFilterStorage()">
                                    {{ meterReading.geographicalRegionName | hasValue }}
                                </td>
                                <td *ngIf="!hasCimDataIntegration" (click)="setFilterStorage()">
                                    {{ meterReading.area| hasValue }}
                                </td>
                                <td *ngIf="hasCimDataIntegration" (click)="setFilterStorage()">
                                    {{ meterReading.subGeographicalRegionName | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.meterNumber | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.meterDigit | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.period | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.lastReading | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.presentReading | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.sltStatus | hasValue }}
                                </td>
                                <td (click)="setFilterStorage()">
                                    --
                                    <!-- <div *ngIf="meterReading.status" class="building-status" 
                                    [ngClass]="{
                                        'assigned-building':
                                        meterReading.status.toString() == 'Assigned',
                                        'rejected-building':
                                        meterReading.status.toString() == 'Rejected',
                                        'approved-building':
                                        meterReading.status.toString() == 'Approved',
                                        'unvalidated-building':
                                        meterReading.status.toString() == 'New',
                                        'submitted-building':
                                        meterReading.status.toString() == 'Submitted'
                                    }">
                                        {{ meterReading.status }}
                                        validation status
                                    </div> -->
                                </td>
                                <td *ngIf="readingSelected === ReadingsMenuTab.AssignedReadings" (click)="setFilterStorage()">{{ outputPriority(meterReading.priority) | hasValue }}</td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.consumption | hasValue }}
                                    <!-- consumption -->
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.estimationStatus | hasValue }}
                                    <!-- estimation status -->
                                </td>
                                <td (click)="setFilterStorage()">
                                    {{ meterReading.creationDate | hasValue }}
                                    <!-- creation date -->
                                </td>
                                <td (click)="setFilterStorage()">
                                    --
                                    <!-- <div class="building-status" [ngClass]="{
                                        'assigned-building': meterReading.tag == 'Onboard',
                                        'approved-building': meterReading.tag == 'Existing'
                                    }">
                                        {{ meterReading.tag | hasValue }}
                                        audit status
                                    </div> -->
                                </td>
                                <!-- <td (click)="setFilterStorage()">
                                    {{ outputBillingStatus(meterReading.billingStatus) | hasValue }}
                                </td> -->
                                <td (click)="setFilterStorage()" class="more-icon">
                                    <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
                            [useDirect]="true" (pageChange)="pageChange($event)"></app-paging>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>